var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('issuable-time-tracker',{attrs:{"full-path":_vm.fullPath,"issuable-id":_vm.issuableId,"issuable-iid":_vm.issuableIid,"limit-to-hours":_vm.limitToHours}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }